// @flow
'use strict';

import { connect } from 'react-redux';

import Detalhes from './detalhes';

export default connect<*, *, *, *, *, *>()(Detalhes);
